/* global customElements, HTMLElement */

class Flipcard extends HTMLElement {
  connectedCallback () {
    this.$toggle = this.querySelector('.js-flipcard__toggle')
    this.$backface = this.querySelector('.js-flipcard__backface')

    this.$toggle.addEventListener('click', () => this.toggle())
    this.$toggle.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        this.toggle()
        return
      }

      if (e.key === 'Escape') {
        e.preventDefault()
        this.toggle(false)
      }
    })
    this.addEventListener('click', (e) => {
      if (e.target.closest('a, button:not(.js-flipcard__toggle)')) {
        return
      }

      this.toggle()
    })
  }

  get isExpanded () {
    return this.$toggle.getAttribute('aria-expanded') === 'true'
  }

  toggle (newState = null) {
    const oldState = this.isExpanded
    newState = typeof newState === 'boolean' ? newState : !this.isExpanded

    if (oldState === newState) {
      return
    }

    this.dispatchEvent(new CustomEvent('flipcard:beforetoggle', {
      bubbles: true,
      detail: {
        isExpanded: newState
      }
    }))

    this.$toggle.setAttribute('aria-expanded', !this.isExpanded)
    this.$backface.setAttribute('aria-hidden', !this.isExpanded.toString())
    this.$backface.inert = !this.isExpanded

    if (this.$toggle.ariaExpanded) {
      this.$backface.focus()
    } else {
      this.$toggle.focus()
    }
  }
}

customElements.define('tb-flipcard', Flipcard)
